(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('PhysicalFairPreApprovedModalController', PhysicalFairPreApprovedModalController)

    PhysicalFairPreApprovedModalController.$inject = ['$uibModalInstance', 'preApprovedItem', 'sellers', 'PhysicalFairService','$timeout'];

    function PhysicalFairPreApprovedModalController($uibModalInstance, preApprovedItem, sellers, PhysicalFairService, $timeout) {
        var vm = this;

        vm.preApprovedItem = preApprovedItem;
        vm.sellers         = sellers;
        vm.seller          = '';
        vm.registered      = 0;
        vm.query           = [];
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.update          = update;

        
        function activate() {
            vm.seller = vm.preApprovedItem.seller_id;
            setTimeout(function () {
                vm.registered = parseInt(preApprovedItem.registered);
            }, 2);
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {
            vm.query['registered']          = vm.registered;
            vm.query['seller']              = vm.seller;
            vm.query['observation']         = vm.preApprovedItem.admin_observation;
            vm.query['pre_register_cod']    = vm.preApprovedItem.id;
            PhysicalFairService.updatePreApproved(vm.query).then(function(response){
                preApprovedItem.registered = vm.registered;
                preApprovedItem.admin_observation = vm.preApprovedItem.admin_observation;
                preApprovedItem.seller_id = vm.seller;
                preApprovedItem.seller = vm.sellers.filter(function (obj) {
                    return obj.id == preApprovedItem.seller_id;
                })[0];
                alertify.notify(response.data, 'success', 3);

            }).catch(function(err) {
                alertify.notify(err, 'danger', 3);
            });
        }
        activate();

    }

})();